// @flow
import { createStore, applyMiddleware, compose } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { defaultInitialState, rootEpic, rootReducer } from '../modules';
import { middlewareCreator } from '../router';

import type { History } from '../router';
import type { RootState } from '../modules';

const configureStore = (initialState?: RootState = defaultInitialState, history: History) => {
  const middleware = [];

  // Redux observable
  const epic = createEpicMiddleware();
  middleware.push(epic);
  // Router
  middleware.push(middlewareCreator(history));

  const appliedMiddlewares = applyMiddleware(...middleware);

  let store;

  if (process.env.WEBAPP_ENV !== 'production' && window) {
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    /* eslint-enable */
    const enhancer = composeEnhancers(
      appliedMiddlewares,
    );
    store = createStore(rootReducer, initialState, enhancer);
  } else {
    store = createStore(rootReducer, initialState, appliedMiddlewares);
  }
  epic.run(rootEpic);
  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./src/store/configureStore.js